import originJsonp from 'jsonp'
import apiTime from './apiTime'

export default function jsonp(pathArr, data, option) {
  let url = pathArr[0] + pathArr[1]
  const realUrl = url + (url.indexOf('?') < 0 ? '?' : '&') + param(data)
  apiTime.setApiTime(pathArr[1])

  return new Promise((resolve, reject) => {
    originJsonp(realUrl, option, (err, res) => {
      if (!err && (res.code === 200 || res.status === 200)) {
        apiTime.reportApiResult(pathArr[1], 1) //上报接口成功时间
        resolve(res)
      } else {
        apiTime.reportApiResult(pathArr[1], 2) //上报接口失败时间
        reject(res)
      }
    })
  })
}

function param(data) {
  let url = ''
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : ''
    url += '&' + k + '=' + encodeURIComponent(value)
  }
  return url ? url.substring(1) : ''
}
